import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReportSchedule, ReportScheduleCreate, ReportScheduleFilter } from '../data/reportSchedule';

export function createReportScheduleService(client: AxiosInstance) {
  return createCrudService<ReportSchedule, ReportScheduleCreate, ReportScheduleFilter>(
    client,
    '/reporting/ReportSchedule',
    'id',
  );
}

export type ReportScheduleService = CrudService<ReportSchedule, ReportScheduleCreate, ReportScheduleFilter>;
